import { defineStore } from "pinia";

export const useCatalogPublicationGeneralStore = defineStore("CatalogPublicationGeneralStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationGeneral() {
      this.loading = true;
      try {
        const response = await this.$axios.get('/api/v1/catalog/general_filters.json');
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    }
  }
});
